import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum AccessRoutesEnum {
    DatatableUsers = '/acesso/usuarios',
    ShowUser = '/acesso/usuarios/:cpf',
    DatatablePrivileges = '/acesso/perfis',
    ShowPrivilege = '/acesso/perfis/:id',
}

export default function AccessRouter() {
    /*Rotas para Usuários*/
    const DatatableUsers = lazy(() => import('../../pages/users/DatatableUsers'))
    const ShowUser = lazy(() => import('../../pages/users/ShowUser'))

    const DatatablePrivileges = lazy(() => import('../../pages/privileges/DatatablePrivileges'))
    const ShowPrivilege = lazy(() => import('../../pages/privileges/ShowPrivilege'))

    return (
        <Container loading={false}>
            <Switch>
                <Route path={AccessRoutesEnum.ShowUser} component={ShowUser} />
                <Route path={AccessRoutesEnum.DatatableUsers} component={DatatableUsers} />
                <Route path={AccessRoutesEnum.ShowPrivilege} component={ShowPrivilege} />
                <Route
                    path={AccessRoutesEnum.DatatablePrivileges}
                    component={DatatablePrivileges}
                />
            </Switch>
        </Container>
    )
}
